const CONTACT_MESSAGES_ENDPOINT = "/api/contact-messages";

const CONTACT_EMAIL = "info.naghshekhial@gmail.com";

export const CONTACT_INFO = {
  email: CONTACT_EMAIL,
  phone: "0912-9516835",
  address: "میدان ونک، خیابان شیخ بهایی شمالی، کوچه امداد غربی",

  instagramUrl: "https://www.instagram.com/naghshekhial_121",
  telegramUrl: "https://t.me/+989129516835",
  whatsappUrl: "https://wa.me/989129516835",
};

const getAuthHeaders = () => {
  const token = localStorage.getItem("authToken");

  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

export const validateContactMessage = (formData) => {
  const errors = {};

  const name = String(formData.name || "").trim();
  const phone = String(formData.phone || "").trim();
  const email = String(formData.email || "").trim();
  const message = String(formData.message || "").trim();

  if (!name) {
    errors.name = "لطفاً نام خود را وارد کنید";
  }

  if (!phone) {
    errors.phone = "لطفاً شماره تماس را وارد کنید";
  } else if (!/^[0-9]{11}$/.test(phone)) {
    errors.phone = "شماره تماس باید ۱۱ رقم باشد";
  }

  if (!email) {
    errors.email = "لطفاً ایمیل را وارد کنید";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errors.email = "ایمیل معتبر نیست";
  }

  if (!message) {
    errors.message = "لطفاً متن پیام را وارد کنید";
  } else if (message.length < 10) {
    errors.message = "متن پیام باید حداقل ۱۰ کاراکتر باشد";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const sendContactMessage = async (formData) => {
  const validation = validateContactMessage(formData);

  if (!validation.isValid) {
    return {
      success: false,
      errors: validation.errors,
      message: "لطفاً خطاهای فرم را بررسی کنید",
    };
  }

  const now = new Date().toISOString();

  let currentUser = null;

  try {
    const savedUser = localStorage.getItem("currentUser");
    currentUser = savedUser ? JSON.parse(savedUser) : null;
  } catch (error) {
    currentUser = null;
  }

  const newMessage = {
    name: String(formData.name || "").trim(),
    phone: String(formData.phone || "").trim(),
    email: String(formData.email || "").trim(),
    subject: "پیام جدید از فرم تماس با ما",
    message: String(formData.message || "").trim(),
    type: "contact",
    status: "new",

    userId: currentUser?.id || null,
    username: currentUser?.username || "",
    userRole: currentUser?.role || "guest",

    createdAt: now,
    updatedAt: now,
  };

  const response = await fetch(CONTACT_MESSAGES_ENDPOINT, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(newMessage),
  });

  if (!response.ok) {
    throw new Error("خطا در ثبت پیام");
  }

  return {
    success: true,
    message: "پیام شما با موفقیت ثبت شد. پشتیبانی نقش خیال آن را بررسی می‌کند.",
    data: await response.json(),
  };
};

export const getContactMessages = async () => {
  const response = await fetch(CONTACT_MESSAGES_ENDPOINT, {
    method: "GET",
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    throw new Error("خطا در دریافت پیام‌ها");
  }

  const messages = await response.json();

  return Array.isArray(messages)
    ? messages.sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0))
    : [];
};

export const updateContactMessageStatus = async (messageId, status) => {
  const response = await fetch(`${CONTACT_MESSAGES_ENDPOINT}/${messageId}`, {
    method: "PATCH",
    headers: getAuthHeaders(),
    body: JSON.stringify({
      status,
      updatedAt: new Date().toISOString(),
    }),
  });

  if (!response.ok) {
    throw new Error("خطا در تغییر وضعیت پیام");
  }

  return response.json();
};
